import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from '../market';

const TELEGRAM_FAQ = [
  {
    title: 'Как работает продвижение через Boostclick?',
    isH3: false,
    text:
      <p>
        Вы создаете проект, указываете ссылку на канал и параметры. Задания получают реальные пользователи, которые выполняют их вручную.
      </p>
  },
  {
    title: 'Когда начнется выполнение проекта?',
    isH3: false,
    text:
      <p>
        Обычно задания начинают выполняться в течение короткого времени после активации проекта.
      </p>
  },
  {
    title: 'Сколько времени займет выполнение проекта?',
    isH3: false,
    text:
      <p>
        Продолжительность выполнения зависит от объема проекта и настроенных параметров.
      </p>
  },
  {
    title: 'Может ли измениться статистика на канале?',
    isH3: false,
    text:
      <p>
        Да, рост подписчиков происходит постепенно, без резких скачков.
      </p>
  },
  {
    title: 'Отписки возможны?',
    isH3: false,
    text:
      <p>
        Да, незначительная отписка 5-10% возможна и считается естественной частью роста аудитории.
      </p>
  },
  {
    title: 'Гарантии и безопасность',
    isH3: false,
    text:
      <p>
        Boostclick предоставляет инструменты для размещения заданий, которые выполняются пользователями по собственному желанию.
        <br />
        Мы не используем автоматизированные методы или ботов.
        <br />
        <br />
        Результаты зависят от интереса исполнителей и параметров заданий.
        <br />
        Мы не гарантируем конкретных показателей и рекомендуем сопровождать продвижение качественным контентом.
      </p>
  },
];

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя, и каждый сценарий начинается для нового исполнителя с перехода на канал по переданной вами ссылке.
</p>;

const CHAIN_PRICE = 6;
const CHAIN_STEPS = 4;

const STEP_PRICE = Number((CHAIN_PRICE / CHAIN_STEPS).toFixed(1));

const ACTIONS = [
  {
    type: 'MAIN.SUBSCRIBE',
    icon: "people",
    iconHome: "home-people",
    title: 'Активная подписка (человек)',
    titleComment: '+\u00a0просмотр\u00a0постов +\u00a0просмотр\u00a0профиля +\u00a0отчет\u00a0о\u00a0работе',
    initialShare: 0.9,
    price: STEP_PRICE,
    activityType: 'Подписка',
  },
  {
    type: 'MAIN.LIKE',
    icon: "like",
    iconHome: "home-like",
    title: 'Поставить лайк / реакцию на пост',
    titleComment: '+\u00a0просмотр\u00a0постов +\u00a0просмотр\u00a0профиля +\u00a0отчет\u00a0о\u00a0работе',
    initialShare: 0,
    activityType: 'Лайк',
  },
  {
    type: 'MAIN.REPOST',
    icon: "message",
    iconHome: "home-repost",
    title: 'Сделать репост поста в ВК',
    initialShare: 0.1,
    activityType: 'Репост',
  },

  { type: 'ALWAYS.OPEN', icon: "open", iconHome: "home-open", title: 'Открыть Telegram', initialShare: 1 },

  {
    type: 'ALWAYS.SEARCH',
    icon: "search",
    iconHome: "home-search",
    title: 'Найти канал / группу',
    titleComment: 'должны быть публичными',
    initialShare: 1,
    price: STEP_PRICE,
  },

  { type: 'EXTRA.SEE', icon: "glasses", iconHome: "home-glasses", title: 'Посмотреть последние 7 постов', initialShare: 0.7, price: STEP_PRICE },
  { type: 'EXTRA.PROFILE', icon: "click", iconHome: "home-click", title: 'Посмотреть профиль', initialShare: 0.3, price: STEP_PRICE },

  {
    type: 'MAIN.SURVEY',
    icon: "click",
    iconHome: "home-click",
    title: 'Поучаствовать в опросе',
    titleComment: 'должен быть активным',
    initialShare: 0,
    activityType: 'Опрос',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-subscribe",
    title: "Подписка + просмотры",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Лайк + просмотры",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  },
  {
    iconHome: "home-repost",
    title: "Репост в VK*",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть Telegram*",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти канал / группу",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Посмотреть последние 7 постов",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Посмотреть профиль",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Поучаствовать в опросе",
    path: "/nakrutka-podpischikov-telegram",
    target: '_self',
  }
];

const TELEGRAM_KEYWORDS = [
  'Telegram', 'telegram', 'Телеграм', 'телеграм', 'tg', 'тг',
];

class TelegramClass extends Market {

  id = 'telegram';
  host = 't.me';
  url = 'https://t.me/';

  title = 'Telegram*';

  isMarketplace = false;

  icon = "telegram";
  titlePlaces = 'Телеграм*';
  statusForHomePage = MARKET_MODE_STATUS.POPULAR;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [];

  chainsPerDayNormal = 400 / 30;

  chainPrice = CHAIN_PRICE;
  chainsMin = 10;
  chainsMax = 500;

  chainsDefault = 30;

  reviewPrice = 0;

  chainsStep = 10;
  viewsStep = 1;

  keywords = TELEGRAM_KEYWORDS;

  targetLinkComment = <span>Укажите тут адрес вашего <b>открытого</b> канала в Телеграм*</span>;
  targetLinkCommentShort = <span>Укажите ссылку на <b>открытый</b> канал</span>;

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      title: 'ПФ',
      navigateTitle: 'Активность: подписки, вовлеченность',
      path: '/nakrutka-podpischikov-telegram',
      rating: 0.20,
      icon: "people",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.REGULAR,
      meta: {
        title: `Подписчики в Telegram от ${CHAIN_PRICE / CHAIN_STEPS} руб. — заказать накрутку ЛЮДИ`,
        description: 'Закажите накрутку подписчиков ЛЮДИ в Telegram через Boostclick.',
        canonical: '/nakrutka-podpischikov-telegram',
      },
      intro: {
        title: 'Продвижение Телеграм* подписчиками',
        comment: 'Через микрозадачи и участие реальных пользователей',
        points: [
          'Без ботов',
          'Только уникальные пользователи',
          'Реальные подписчики',
          'Подробные отчеты',
          'Гибкие настройки проекта',
        ]
      },
      howItWorks: [
        'Распределите активности',
        'Укажите ссылку на Телеграм канал / чат',
        'Сервис создаст задания для исполнителей',
        'Исполнители выполнят задания и пришлют отчеты',
        'Проверьте отчеты, если все верно примите их, если есть ошибки, то смените исполнителя',
      ],
      stepPhrase1: 'Настройте параметры привлечения подписчиков в Телеграм*',
      stepPhrase2: 'Укажите информацию для поиска канала',
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Продвижение канала в Telegram*',
      titleFAQ: "Вопрос-ответ",
      faq: TELEGRAM_FAQ,
      actions: ACTIONS,
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов.',
        'Boostclick предоставляет доступ к платформе, где исполнители получают задания и переходят в ваш Телеграм-канал* по ссылке.',
        'Каждый пользователь выполняет задания вручную — это может включать просмотр канала, подписку и другие действия.',
        'Поведение варьируется в зависимости от сценария и количества действий в рамках проекта.',
        'Сроки выполнения зависят от объема и настроек задания.',
      ]
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на канал или группу';
  invalidUrlStr = 'Укажите корректную ссылку на канал или группу';
}

const Telegram = new TelegramClass();
export default Telegram;
